var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"media",attrs:{"src":_vm.item.preview}}),_c('div',{staticClass:"icons"},[_c('PhotoIcon'),(_vm.item.hasThreeD)?_c('ThreeDIcon'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }